import { createFileRoute } from '@tanstack/react-router';
import { DesktopLots } from '@/features/warehouse/DesktopLotti';

/** I lotti col certificato: senza un lotto un articolo tracciato non si può caricare. */
export const Route = createFileRoute('/_app/warehouse/lots')({ component: DesktopLots });
